/* eslint-disable no-unused-vars */
/* eslint-disable semi */
import {
  get,
  post
} from './axios'
var root = process.env.API_HOST
export const apiAddress = params => post(root + 'goodsCategory/list.json', params)
export const recommendImg = params => post('user/recommendImg.json', params) // 非会员页面的商品图片
export const findVipPriceList = params => post('userVipPrice/findVipPriceList.json', params) // 开通会员以及续费接口
export const recommendGoods = params => post('user/recommendGoods.json', params) // 会员商品图片接口
export const vipCouponList = params => post('userCoupon/vipCouponList.json', params) // 会员优惠券接口
export const addCouponBatch = params => post('userCoupon/addCouponBatch.json', params) // 会员一键领取优惠券接口
export const vipRights = params => post('user/vipRights.json', params) // 会员信息



// WEBPACK FOOTER //
// ./src/request/api.js